<template>
  <span>
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.59 5.37C21.47 6.36 22 7.66 22 9.09C22 16.09 15.52 20.22 12.62 21.22C12.28 21.34 11.72 21.34 11.38 21.22C8.48 20.22 2 16.09 2 9.09C2 6 4.49 3.5 7.56 3.5C9.38 3.5 10.99 4.38 12 5.74C13.01 4.38 14.63 3.5 16.44 3.5" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
  }
}
</script>